/**
 * WhatItIs - A class for handling functionality
 */
class WhatItIs {
	static setup() {
		const elements = document.querySelectorAll('.is-style-section-what-it-is');
		for (const element of elements) {
			const instance = new WhatItIs(element);
			instance.init();
		}
	}

	constructor(element) {
		this.element = element;
		this.toggles = this.element.querySelectorAll('.wp-block-qte-theme-toggle');
		this.images = this.element.querySelectorAll('.wp-block-column:has( > .wp-block-image) figure');
		this.currentIndex = 0;
		this.autoplay = true;
		this.intervalTime = 15000; // 15s per slide
		this.timer = null;

		// set CSS variable based on intervalTime
		this.element.style.setProperty('--slide-duration', `${this.intervalTime}ms`);
	}

	init() {
		if (!this.toggles.length || !this.images.length) {
			return;
		}

		this.addEventListeners();
		this.showByIndex(0);
		this.startAutoplay();
	}

	addEventListeners() {
		this.toggles.forEach((toggle, index) => {
			const header = toggle.querySelector('.wp-block-qte-theme-collapsible');
			if (!header) return;

			header.addEventListener('click', () => {
				this.stopAutoplay();
				this.showByIndex(index);
			});
		});
	}

	showByIndex(index) {
		this.currentIndex = index;

		this.toggles.forEach((toggle, i) => {
			const collapsible = toggle.querySelector('.wp-block-qte-theme-collapsible');

			if (!collapsible) return;

			if (i === index) {
				toggle.classList.add('open');
				collapsible.setAttribute('aria-expanded', 'true');

				// Progress bar handling
				toggle.classList.remove('progressing', 'filled');
				if (this.autoplay) {
					toggle.classList.add('progressing');
				} else {
					toggle.classList.add('filled');
				}
			} else {
				toggle.classList.remove('open', 'progressing', 'filled');
				collapsible.setAttribute('aria-expanded', 'false');
			}
		});

		// Handle images
		this.images.forEach((img, i) => {
			if (i === index) {
				img.classList.add('show');
				img.classList.remove('hide');
			} else {
				img.classList.add('hide');
				img.classList.remove('show');
			}
		});
	}

	startAutoplay() {
		if (!this.autoplay) return;

		this.timer = setInterval(() => {
			const nextIndex = (this.currentIndex + 1) % this.toggles.length;
			this.showByIndex(nextIndex);
		}, this.intervalTime);
	}

	stopAutoplay() {
		this.autoplay = false;
		clearInterval(this.timer);
	}
}

if (document.readyState === 'interactive' || document.readyState === 'complete') {
	WhatItIs.setup();
} else {
	document.addEventListener('DOMContentLoaded', WhatItIs.setup);
}
